import { DropdownOption } from 'types/dropdown';
import { TabPill } from 'types/tabs';

import { GstAddress, GstInput, GstOptions, GstPercentage } from './types';

export const FineOptions: DropdownOption[] = [
  {
    id: 'percentage',
    label: 'Percentage',
    value: 'percentage'
  },
  {
    id: 'flat',
    label: 'Flat',
    value: 'flat'
  }
];

export const gstDataDefualtValue: GstPercentage = {
  cgst: '9',
  sgst: '9',
  igst: null
};

export const AddressDefaultValue: GstAddress = {
  line1: '',
  line2: '',
  city: '',
  state: '',
  pincode: '',
  country: ''
};

export const gstInputDefaultValue: GstInput = {
  showGstDetails: false,
  gstIn: '',
  hsnCode: '',
  address: AddressDefaultValue,
  gstValue: gstDataDefualtValue,
  selectedGstType: GstOptions.EXCLUSIVE
};

export const integrationTabs: TabPill[] = [
  { id: 1, label: 'Organization Settings' },
  { id: 2, label: 'API Keys' },
  { id: 3, label: 'Webhooks' },
  { id: 4, label: 'WhatsApp Integration' },
  { id: 5, label: 'SDK Configuration' }
];

export const APIKeysData = [
  {
    id: '1',
    name: 'Test 1',
    date: '06 Feb 2025 12:07 PM',
    key: '1234567890123'
  },
  {
    id: '2',
    name: 'Test 2',
    date: '06 Feb 2025 12:07 PM',
    key: '1234567890123'
  },
  {
    id: '3',
    name: 'Test 3',
    date: '06 Feb 2025 12:07 PM',
    key: '1234567890123'
  }
];

export const HTTPSHeaders = [
  { id: '1', headerName: 'header 1', headerValue: 'headerval 1' },
  { id: '2', headerName: 'header 2', headerValue: 'headerval 2' }
];

export const webhookData = [
  {
    id: '1',
    name: 'webhook1',
    url: 'webhook url',
    headers: [{ id: '1', headerName: 'header1', headerValue: 'header value1' }]
  }
];

export const getAllWebhookListApi = {
  code: 'success',
  message: 'success',
  data: {
    items: [
      {
        created_at: '2025-02-10T13:23:44+05:30',
        updated_at: '2025-02-10T13:23:44+05:30',
        deleted_at: null,
        id: 'f866fbc5-9fd4-4ffd-a467-e3660ee3f8ff',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'payment trigger invoice',
        type: 'WEBHOOK',
        enabled_at: '2025-02-10T13:23:44+05:30',
        disabled_at: '1970-01-01T05:30:00+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-10T13:23:44+05:30',
          updated_at: '2025-02-10T13:23:44+05:30',
          deleted_at: null,
          id: '534c0a0d-d27a-4fa6-88f0-6e5a0cd9316e',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: 'f866fbc5-9fd4-4ffd-a467-e3660ee3f8ff',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-application-header': 'custom header'
          },
          signing_secret: 'p9JtZV0EoxTne1BKFCw5MsM_PhRlrW35VfO8vaZ7BN0=',
          signing_algo: 'SHA256'
        }
      },
      {
        created_at: '2025-02-07T17:29:43+05:30',
        updated_at: '2025-02-07T17:29:43+05:30',
        deleted_at: null,
        id: '7451ae1e-f1b0-4f03-b80c-b8c33328043d',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'payment trigger 4',
        type: 'WEBHOOK',
        enabled_at: '2025-02-07T17:29:43+05:30',
        disabled_at: '1970-01-01T05:30:00+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-07T17:29:43+05:30',
          updated_at: '2025-02-07T17:29:43+05:30',
          deleted_at: null,
          id: 'ba1db145-3554-4198-a1f6-16894cd0b4da',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: '7451ae1e-f1b0-4f03-b80c-b8c33328043d',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-application-header': 'custom header'
          },
          signing_secret: 'XMLDi4xBG0e1_oVTTv3hW2XNjRDMxV-GyZcdPB61Fn8=',
          signing_algo: 'SHA256'
        }
      },
      {
        created_at: '2025-02-06T17:07:36+05:30',
        updated_at: '2025-02-06T17:07:36+05:30',
        deleted_at: null,
        id: '053379b1-4850-4775-8298-80d15b9cc6ed',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'payment trigger 3',
        type: 'WEBHOOK',
        enabled_at: '2025-02-06T17:07:36+05:30',
        disabled_at: '1970-01-01T05:30:00+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-06T17:07:36+05:30',
          updated_at: '2025-02-06T17:07:36+05:30',
          deleted_at: null,
          id: '1ad4d0aa-3021-4705-8c85-42060d1b7f08',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: '053379b1-4850-4775-8298-80d15b9cc6ed',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-application-header': 'custom header'
          },
          signing_secret: 'opORTZRZ4yl1CVeWemZHQS7Co_ajvveHHoO4zNvNsHA=',
          signing_algo: 'SHA256'
        }
      },
      {
        created_at: '2025-02-06T16:24:30+05:30',
        updated_at: '2025-02-07T17:34:56+05:30',
        deleted_at: null,
        id: '057c6a2b-2884-4071-b651-503acd1652ca',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'trigger name changed',
        type: 'WEBHOOK',
        enabled_at: '2025-02-07T13:06:24+05:30',
        disabled_at: '2025-02-07T13:06:09+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-06T16:24:30+05:30',
          updated_at: '2025-02-07T17:34:56+05:30',
          deleted_at: null,
          id: 'df6485ef-ba7d-456b-b592-18d856ba1ae5',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: '057c6a2b-2884-4071-b651-503acd1652ca',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-test-header': 'x-test-header'
          },
          signing_secret: 'ld54GhcXDp40EVhKT0BEys1otQmG56RA21lqUUzv1BY=',
          signing_algo: 'SHA256'
        }
      },
      {
        created_at: '2025-02-06T16:03:29+05:30',
        updated_at: '2025-02-06T17:01:03+05:30',
        deleted_at: '2025-02-06T17:01:03+05:30',
        id: 'e4a82d38-220b-401c-84ac-5bc98ae2e484',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'payment trigger',
        type: 'WEBHOOK',
        enabled_at: '2025-02-06T16:03:29+05:30',
        disabled_at: '1970-01-01T05:30:00+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-06T16:03:29+05:30',
          updated_at: '2025-02-06T16:03:29+05:30',
          deleted_at: null,
          id: '9acd7cb5-fbd6-4438-b53f-39778bc54a07',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: 'e4a82d38-220b-401c-84ac-5bc98ae2e484',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-application-header': 'custom header'
          },
          signing_secret: 'nftc5RLgywiCDTR3FxDlqOOJWGlu8U4C5d4RW_URLsg=',
          signing_algo: 'SHA256'
        }
      },
      {
        created_at: '2025-02-06T16:03:29+05:30',
        updated_at: '2025-02-06T17:01:03+05:30',
        deleted_at: '2025-02-06T17:01:03+05:30',
        id: 'e4a82d38-220b-401c-84ac-5bc98ae2e487',
        org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
        name: 'payment trigger',
        type: 'WEBHOOK',
        enabled_at: '2025-02-06T16:03:29+05:30',
        disabled_at: '1970-01-01T05:30:00+05:30',
        trigger_events: null,
        webhook_config: {
          created_at: '2025-02-06T16:03:29+05:30',
          updated_at: '2025-02-06T16:03:29+05:30',
          deleted_at: null,
          id: '9acd7cb5-fbd6-4438-b53f-39778bc54a07',
          org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
          trigger_id: 'e4a82d38-220b-401c-84ac-5bc98ae2e484',
          url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
          custom_headers: {
            'x-application-header': 'custom header'
          },
          signing_secret: 'nftc5RLgywiCDTR3FxDlqOOJWGlu8U4C5d4RW_URLsg=',
          signing_algo: 'SHA256'
        }
      }
    ],
    total_count: 5
  }
};

export const getWebhookByIdData = {
  created_at: '2025-02-10T13:23:44+05:30',
  updated_at: '2025-02-10T13:23:44+05:30',
  deleted_at: null,
  id: 'f866fbc5-9fd4-4ffd-a467-e3660ee3f8ff',
  org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
  name: 'payment trigger invoice',
  type: 'WEBHOOK',
  enabled_at: '2025-02-10T13:23:44+05:30',
  disabled_at: '1970-01-01T05:30:00+05:30',
  trigger_events: null,
  webhook_config: {
    created_at: '2025-02-10T13:23:44+05:30',
    updated_at: '2025-02-10T13:23:44+05:30',
    deleted_at: null,
    id: '534c0a0d-d27a-4fa6-88f0-6e5a0cd9316e',
    org_id: '88b19c2d-93aa-45d3-ba31-06ab56be7421',
    trigger_id: 'f866fbc5-9fd4-4ffd-a467-e3660ee3f8ff',
    url: 'https://webhook.site/6b1fd80a-d19c-40f2-832d-0d54916dee3e',
    custom_headers: {
      'x-application-header': 'custom header'
    },
    signing_secret: 'p9JtZV0EoxTne1BKFCw5MsM_PhRlrW35VfO8vaZ7BN0=',
    signing_algo: 'SHA256'
  }
};

export const allApiKeysDataApi = {
  code: 'success',
  message: 'success',
  data: {
    items: [
      {
        id: '18daf932-b9df-457a-aa6e-d8c4dc99770a',
        api_key_name: 'nami',
        api_key: '********************************************niXZ',
        created_at: '2025-02-12T14:26:26+05:30'
      },
      {
        id: 'c50cff79-a494-4d31-be5b-7f1e573ca26e',
        api_key_name: 'zoro',
        api_key: '********************************************OrZr',
        created_at: '2025-02-12T13:43:39+05:30'
      },
      {
        id: '2603e3eb-af17-40b3-b018-cba348240742',
        api_key_name: 'mokeydluffy',
        api_key: '********************************************ioRI',
        created_at: '2025-02-12T13:21:51+05:30'
      },
      {
        id: '2603e3eb-af17-40b3-b018-cba348240743',
        api_key_name: 'mokeydluffy',
        api_key: '********************************************ioRI',
        created_at: '2025-02-12T13:21:51+05:30'
      },
      {
        id: '2603e3eb-af17-40b3-b018-cba348240744',
        api_key_name: 'mokeydluffy',
        api_key: '********************************************ioRI',
        created_at: '2025-02-12T13:21:51+05:30'
      },
      {
        id: '2603e3eb-af17-40b3-b018-cba348240745',
        api_key_name: 'mokeydluffy',
        api_key: '********************************************ioRI',
        created_at: '2025-02-12T13:21:51+05:30'
      }
    ],
    total_count: 3
  }
};

export const gstOptions = [
  {
    key: GstOptions.EXCLUSIVE,
    value: 'Exclusive GST'
  },
  {
    key: GstOptions.INCLUSIVE,
    value: 'Inclusive GST'
  },
  {
    key: GstOptions.COMPOSITION,
    value: 'Composition GST'
  }
];

export const WhatsAppIntegrationSelectionOptions = [
  { id: 'provider', value: 'provider', label: 'WhatsApp Provider' },
  { id: 'templates', value: 'templates', label: 'Templates' }
];

export const HIDE_APPLY_DISCOUNT_IN_CUSTOM_TERM = true;

export const SCHEDULE_REMINDER_MAX_DAYS = 62;
